const currentMarket = Shopify.locale;
console.log("Market activo:", currentMarket);
const contenedorBotones = document.querySelector('.product-form__buttons');

// 🔧 Normalizador para size
function normalizeSizeValue(value) {
  return value
    .replace(/["']/g, '')         // quitar comillas
    .replace(/\s*x\s*/gi, 'x')    // quitar espacios alrededor de la x
    .replace(/\s+/g, '-')         // reemplazar espacios por guiones
    .replace(/-in$/i, '-in');     // asegurarse que termina con -in si aplica
}

frameBuilder = function frameBuilder(option) {
  console.log("frame: " + option);
  artwork = document.querySelector("#art-container");
  selectedOption = option.value.trim();
  artwork.dataset.frame = selectedOption;
  images_slider = document.querySelector('[id^="Slider-Gallery-"]');
  console.log("slider:" + images_slider);
  images_slider.scrollLeft = 0;
  
  frameOption = selectedOption;
  sizeOption = normalizeSizeValue(
    document.querySelector('input[data-type="size"]:checked').value.trim()
  );
  pptOption = document
    .querySelector('input[data-type="ppt"]:checked')
    .className.trim();
  console.log(
    "frame: " + frameOption + " size: " + sizeOption + " ppt: " + pptOption
  );
};

sizeBuilder = function sizeBuilder(option) {
  console.log("size: " + option);
  artwork = document.querySelector("#art-container");
  selectedOption = normalizeSizeValue(option.value.trim());
  artwork.dataset.size = selectedOption;
  images_slider = document.querySelector('[id^="Slider-Gallery-"]');
  console.log("slider:" + images_slider);
  images_slider.scrollLeft = 0;
  
  frameOption = document
    .querySelector('input[data-type="frame"]:checked')
    .className.trim();
  sizeOption = selectedOption;
  pptOption = document
    .querySelector('input[data-type="ppt"]:checked')
    .className.trim();
  console.log(
    "frame: " + frameOption + " size: " + sizeOption + " ppt: " + pptOption
  );
  
};

pptBuilder = function pptBuilder(option) {
  console.log("ppt: " + option);
  artwork = document.querySelector("#art-container");
  selectedOption = option.value.trim();
  artwork.dataset.ppt = selectedOption;
  images_slider = document.querySelector('[id^="Slider-Gallery-"]');
  console.log("slider:" + images_slider);
  images_slider.scrollLeft = 0;
  
  frameOption = document
    .querySelector('input[data-type="frame"]:checked')
    .className.trim();
  sizeOption = normalizeSizeValue(
    document.querySelector('input[data-type="size"]:checked').value.trim()
  );
  pptOption = selectedOption;
  console.log(
    "frame: " + frameOption + " size: " + sizeOption + " ppt: " + selectedOption
  );

};

initialBuilder = function initialBuilder() {
  artwork = document.querySelector("#art-container");
  frameOption = document
    .querySelector('input[data-type="frame"]:checked')
    .className.trim();
  sizeOption = normalizeSizeValue(
    document.querySelector('input[data-type="size"]:checked').value.trim()
  );
  pptOption = document
    .querySelector('input[data-type="ppt"]:checked')
    .className.trim();
  console.log(
    "frame: " + frameOption + " size: " + sizeOption + " ppt: " + pptOption
  );
  artwork.dataset.frame = frameOption;
  artwork.dataset.size = sizeOption;
  artwork.dataset.ppt = pptOption;
  
};

initialBuilder();
